import React, { useContext, useEffect } from "react";
import { BsExclamationCircle } from "react-icons/bs";
import useDocTitle from "../hooks/useDocTitle";
import FilterBar from "../components/filters/FilterBar";
import ProductCard from "../components/product/ProductCard";
import filtersContext from "../contexts/filters/filtersContext";
import EmptyView from "../components/common/EmptyView";
import commonContext from "../contexts/common/commonContext";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import useActive from "../hooks/useActive";
import { useState ,useRef } from "react";
import '../styles/dropdown.css'
const AllProducts = () => {
  useDocTitle("Wszystkie produkty");
  const { fetchProducts, productsLoading } = useContext(commonContext);
  const { allProducts, updatedCategoryMenu, handleCategoryMenu } =
    useContext(filtersContext);

  const { activeClass, handleActive } = useActive(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("Select an Option");

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelect = (item) => {
    setSelectedItem(item);
    setIsOpen(false);
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
    }
};
const dropdownRef = useRef(null);
  //   {updatedCategoryMenu.map((item) => {
  //     const { id, checked, label } = item;
  //     return (
  //       <li key={id} className="filter_btn">
  //         <input
  //           type="checkbox"
  //           id={label}
  //           value={label}
  //           checked={checked}
  //           onChange={() => handleCategoryMenu(id)}
  //         />
  //         <label htmlFor={label}>{label}</label>
  //       </li>
  //     );
  //   })}
  // </ul>

  useEffect(() => {
    fetchProducts();
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // console.log("updatedCategoryMenuupdatedCategoryMenu", updatedCategoryMenu);

  return (
    <>
      {!allProducts.length && productsLoading ? (
        <div className="loader-container">
          <Box sx={{ display: "flex" }}>
            <CircularProgress
              size={60}
              sx={{
                color: "#FF0000", // Custom color
              }}
            />
          </Box>
        </div>
      ) : (
        <>
          <div className="products_filter_tabs">
            <ul className="tabs">
              {updatedCategoryMenu?.map((item, i) => {
                const { id, checked, label } = item;
                return (
                  <li
                    key={i}
                    className={`tabs_item ${activeClass(i)}`}
                    onClick={() => {
                      handleActive(i);
                      handleCategoryMenu(id);
                    }}
                  >
                    {label.charAt(0).toUpperCase() + label.slice(1)}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="dropdown" ref={dropdownRef}>
      <button className="dropdown-toggle" onClick={handleToggle}>
        {selectedItem}
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          <li onClick={() => handleSelect("Action")}>Action</li>
          <li onClick={() => handleSelect("Another Action")}>
            Another Action
          </li>
          <li onClick={() => handleSelect("Something Else")}>
            Something Else
          </li>
        </ul>
      )}
    </div>
          <section id="all_products" className="section">
            <FilterBar />

            <div className="container">
              {allProducts.length ? (
                <div className="wrapper products_wrapper">
                  {allProducts.map((item) => (
                    <ProductCard key={item.id} {...item} />
                  ))}
                </div>
              ) : (
                <EmptyView
                  icon={<BsExclamationCircle />}
                  msg="Nie znaleziono produktów"
                />
              )}
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default AllProducts;
